if (!customElements.get('g-fulfillment-finder')) {
  class FulfillmentFinder extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        loading: '.js_loading',
        content: '.fulfillment-finder-content',
      };
      this.modal = document.querySelector('#fulfillmentFinderModal');
      this.email = this.getAttribute('data-email');
      this.title = this.modal.title;
      this.modal.addEventListener('modal:close', () => {
        this.close();
      });
    }
    connectedCallback() {
      this.domNodes = queryDomNodes(this.selectors, this);
      GkifyEvents.subscribe('InteractionTriggeredTask', () => {
        window.GkifyLibs.loadjs('https://cdn.shopify.com/s/files/1/0714/7025/2286/files/17tracking.js?v=1734771745');
      });
    }
    close() {
      // 还原最初状态
      this.domNodes.content.classList.add('g:hidden');
      this.domNodes.loading.classList.remove('g:hidden');
      // 隐藏iframe
      this.domNodes.content.querySelectorAll('iframe').forEach((iframe) => {
        iframe.setAttribute('src', '');
        iframe.style.display = 'none';
      });
      this.modal.title = `${this.title}`;
    }
    async render(data) {
      let { trackingNumber, provider } = data;
      let provider_name = provider.provider_name.toLocaleLowerCase();
      if (!provider_name) {
        this.error('provider is empty');
        setTimeout(() => {
          this.modal.close();
        }, 200);
        return;
      }
      if (!trackingNumber) {
        this.error('tracking number is empty');
        this.modal.close();
        return;
      }
      this.modal.title = `${this.title} - ${trackingNumber}`;
      if (provider_name.indexOf('Amaz'.toLocaleLowerCase()) != -1 && provider.provider_url) {
        await this.Amazon(trackingNumber, provider.provider_url);
      } else {
        await this.tranking_17(trackingNumber);
      }
      this.domNodes.loading.classList.add('g:hidden');
      this.domNodes.content.classList.remove('g:hidden');
    }
    async fetchData(params) {
      //params : email order_id tracking_number
      //type 值判定  shopify，tk，amazon
      let type = getTypeByOrder(params.order_id);
      params.type = type;
      this.email = this.getAttribute('data-email');
      let res = await fetch(`/apps/esrvip/common/platform-order-track`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
      });
      return await res.json();
    }
    async Amazon(number, url) {
      setTimeout(() => {
        this.modal.close();
      }, 200);
      if (url.indexOf('%number%') != -1) {
        url = url.replace('%number%', number);
      } else {
        url = url + `?id=${number}`;
      }
      // 因为亚马逊设置了同源策略导致无法直接打开iframe，所以需要使用window.open
      window.open(url, '_blank');

      // let iframeDom = document.getElementById('Amazon')?.querySelector('iframe');
      // iframeDom && iframeDom.setAttribute('src', url);
      // iframeDom.style.display = 'block';
      // return new Promise((resolve, reject) => {
      //   iframeDom.onload = () => {
      //     resolve();
      //   };
      // });
    }
    async tranking_17(number) {
      await window?.YQV5.trackSingle({
        //必须，指定承载内容的容器ID。
        YQ_ContainerId: '17tracking',
        //可选，指定查询结果高度，最大为800px，默认为560px。
        YQ_Height: '500',
        //可选，指定运输商，默认为自动识别。
        YQ_Fc: '0',
        //可选，指定UI语言，默认根据浏览器自动识别。
        YQ_Num: number,
      });
      let iframeDom = document.getElementById('17tracking')?.querySelector('iframe');
      iframeDom && iframeDom.setAttribute('height', 'auto');
      //iframe加载成功
      return new Promise((resolve, reject) => {
        if (iframeDom) {
          iframeDom.onload = () => {
            resolve();
          };
        }
      });
    }
    error(content) {
      GkifyTheme.Notification.show({
        target: document.body,
        method: 'appendChild',
        type: 'error',
        message: content,
        sticky: true,
      });
    }
  }

  customElements.define('g-fulfillment-finder', FulfillmentFinder);
}
